import React from "react";

import { useSelector } from "react-redux";
import { selectScoreInfo } from "store/ExamStore/selectors";
import Skeleton from "react-loading-skeleton";
import { ResultScoreItem } from "../components/ResultScoreItem";

type Props = {
  loading?: boolean;
};
export const ScoreBlock = ({ loading }: Props) => {
  const scoreInfo = useSelector(selectScoreInfo);
  if (window.location.search.includes("isFreeForm=true")) {
    return <></>;
  }
  return (
    <article>
      {loading ? (
        <div className="w-[168px] h-24">
          <Skeleton />
          <div className="flex w-full flex-col flex flex-col space-y-2 mt-5 xs:min-w-[auto]">
            <Skeleton height={40} />
            <Skeleton height={40} />
          </div>
        </div>
      ) : (
        <>
          <h3>Survey & Questionnaire Results</h3>
          <div className="min-w-[320px] flex flex-col space-y-2 mt-5 xs:min-w-[auto]">
            <ResultScoreItem
              title="Post Exam Survey Score"
              value={scoreInfo.survey}
            />
            <ResultScoreItem title="Pain Scale" value={scoreInfo.painScale} />
          </div>
        </>
      )}
    </article>
  );
};
